module.exports = __webpack_public_path__ + "img/Import_12pt.fffb157d.svg";